import { AlertTriangle, AlertCircle, HelpCircle } from "lucide-react";
import Modal from "./Modal";
import Button from "./Button";

interface ConfirmModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  message: string;
  confirmText?: string;
  cancelText?: string;
  variant?: "danger" | "warning" | "info";
  isLoading?: boolean;
}

export default function ConfirmModal({
  isOpen,
  onClose,
  onConfirm,
  title,
  message,
  confirmText = "Confirmar",
  cancelText = "Cancelar",
  variant = "danger",
  isLoading = false,
}: ConfirmModalProps) {
  const icons = {
    danger: <AlertTriangle className="w-12 h-12 text-red-400" />,
    warning: <AlertCircle className="w-12 h-12 text-yellow-400" />,
    info: <HelpCircle className="w-12 h-12 text-blue-400" />,
  };

  const buttonVariants = {
    danger: "danger",
    warning: "primary",
    info: "primary",
  } as const;

  return (
    <Modal isOpen={isOpen} onClose={onClose} className="max-w-md">
      <div className="text-center">
        <div className="flex justify-center mb-4">{icons[variant]}</div>
        <h3 className="text-xl font-semibold text-text-primary mb-2">
          {title}
        </h3>
        <p className="text-text-secondary mb-6">{message}</p>
        <div className="flex items-center justify-center gap-4">
          <Button variant="secondary" onClick={onClose} disabled={isLoading}>
            {cancelText}
          </Button>
          <Button
            variant={buttonVariants[variant]}
            onClick={onConfirm}
            isLoading={isLoading}
          >
            {confirmText}
          </Button>
        </div>
      </div>
    </Modal>
  );
}
